var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Sorry, not found.")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Save me")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }